var map = {
	"./isreal/cards-01.png": 78774,
	"./isreal/cards-02.png": 60397,
	"./isreal/cards-03.png": 20452,
	"./isreal/cards-04.png": 2107,
	"./isreal/cards-05.png": 87890,
	"./isreal/cards-06.png": 78601,
	"./isreal/cards-07.png": 23776,
	"./jawwal/jawwal-10.png": 77919,
	"./jawwal/jawwal-100.png": 70799,
	"./jawwal/jawwal-15.png": 25906,
	"./jawwal/jawwal-20.png": 90446,
	"./jawwal/jawwal-200.png": 50380,
	"./jawwal/jawwal-25.png": 63411,
	"./jawwal/jawwal-30.png": 14537,
	"./jawwal/jawwal-35.png": 34532,
	"./jawwal/jawwal-40.png": 17240,
	"./jawwal/jawwal-45.png": 37541,
	"./jawwal/jawwal-50.png": 67491,
	"./jawwal/jawwal-60.png": 16242,
	"./jawwal/jawwal-70.png": 81245,
	"./jawwal/jawwal-80.png": 8844,
	"./jawwal/jawwal-90.png": 35831,
	"./jawwal/jawwal-empty.png": 61905,
	"./ooredoo/ooredoo-0.png": 22784,
	"./ooredoo/ooredoo-10.png": 81357,
	"./ooredoo/ooredoo-100.png": 76633,
	"./ooredoo/ooredoo-15.png": 75360,
	"./ooredoo/ooredoo-20.png": 67688,
	"./ooredoo/ooredoo-200.png": 35258,
	"./ooredoo/ooredoo-25.png": 57269,
	"./ooredoo/ooredoo-30.png": 26867,
	"./ooredoo/ooredoo-35.png": 84526,
	"./ooredoo/ooredoo-40.png": 74206,
	"./ooredoo/ooredoo-45.png": 2627,
	"./ooredoo/ooredoo-50.png": 98617,
	"./ooredoo/ooredoo-60.png": 69668,
	"./ooredoo/ooredoo-70.png": 2671,
	"./ooredoo/ooredoo-80.png": 46458,
	"./ooredoo/ooredoo-90.png": 90085
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6053;